import { useSelector } from "react-redux";
import { selectFeature } from "./selectors";
import { FeatureName } from "dora-contracts";

const useFeature = (feature: FeatureName) => {
  return useSelector(selectFeature(feature));
};

export default useFeature;
